import { Collapse, Grid, Stack } from '@mui/material';
import React from 'react';
import { CampaignStatusView } from '../CampaignStatusView';
import { Brand } from '@retail/auth/types';
import { BrandCampaign, CentralCampaignType } from '@retail/campaign/types';
import { CampaignName } from './CampaignName';
import { CampaignPeriod } from './CampaignPeriod';
import { CampaignPurchasePeriod } from './CampaignPurchasePeriod';
import { CampaignMandatory } from './CampaignMandatory';
import { CampaignBrands } from './CampaignBrands';
import { CampaignDescription } from './CampaignDescription';
import { MetadataBox } from './MetadataBox';
import { CampaignTypeView } from './CampaignTypeView';
import { MetadataHeader } from './MetadataHeader';

interface Props {
  campaign: BrandCampaign;
  onSaveCampaignName?: (campaignName: string) => void;
  onSaveCampaignPeriod?: (validFrom: Date, validTo: Date) => void;
  onSavePurchasePeriod?: (purchasePeriodFrom: Date, purchasePeriodTo: Date) => void;
  onSaveMandatory?: (mandatory: boolean) => void;
  onSaveBrands?: (brandIds: string[]) => void;
  onSaveDescription?: (description: string) => void;
  onSaveCampaignType?: (type: CentralCampaignType) => void;
  availableBrands: Brand[];
}

export const BrandCampaignMetadata = ({
  campaign,
  onSaveCampaignName,
  onSaveCampaignPeriod,
  onSavePurchasePeriod,
  onSaveMandatory,
  onSaveBrands,
  onSaveDescription,
  onSaveCampaignType,
  availableBrands,
}: Props) => {
  return (
    <MetadataBox>
      {({ isOpen, onToggle }) => (
        <>
          <MetadataHeader isOpen={isOpen} onToggle={onToggle}>
            <Stack justifyContent="space-between" direction="row" flexGrow={1} spacing={1}>
              <CampaignName name={campaign.name} onSave={onSaveCampaignName} />
              <CampaignStatusView status={campaign.releaseStatus} />
            </Stack>
          </MetadataHeader>

          <Collapse in={isOpen}>
            <Grid container rowSpacing={0.5} columnSpacing={4} mx={1}>
              <Grid size={3}>
                <CampaignPeriod
                  validFrom={campaign.validFrom}
                  validTo={campaign.validTo}
                  onSave={onSaveCampaignPeriod}
                />
              </Grid>
              <Grid size={3}>
                <CampaignPurchasePeriod
                  from={campaign.purchasePeriodFrom}
                  to={campaign.purchasePeriodTo}
                  onSave={onSavePurchasePeriod}
                />
              </Grid>
              <Grid size={3}>
                <CampaignMandatory mandatory={campaign.mandatory} onSave={onSaveMandatory} />
              </Grid>
              <Grid size={3} />
              <Grid size={3}>
                <CampaignBrands
                  brands={campaign.brands}
                  availableBrands={availableBrands}
                  onSave={onSaveBrands}
                />
              </Grid>
              <Grid size={3}>
                <CampaignTypeView type={campaign.campaignType} onSave={onSaveCampaignType} />
              </Grid>
              <Grid size={6}>
                <CampaignDescription
                  description={campaign.description}
                  onSave={onSaveDescription}
                />
              </Grid>
            </Grid>
          </Collapse>
        </>
      )}
    </MetadataBox>
  );
};
